import * as React from 'react'
import {Dialog, DialogContent, IconButton, Box} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {SUBTLE} from '../../../styles/foundation/colors'

/**
 * Single-image viewer. A thin wrapper around MUI's Dialog, which already
 * gives us the two accessibility requirements for free:
 *  - Escape closes it (Dialog calls onClose(event, 'escapeKeyDown') unless
 *    disableEscapeKeyDown is set, which it isn't here).
 *  - Focus returns to whatever element opened it (Modal's default
 *    restoreFocus behaviour), as long as that element is still on screen —
 *    true here since the drawer that hosts the trigger thumbnail stays open
 *    underneath the lightbox.
 */
export default function Lightbox({src, alt, open, onClose}) {
  if (!src) return null

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogContent sx={{position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2}}>
        <IconButton
          onClick={onClose}
          aria-label='Close image'
          size='small'
          sx={{position: 'absolute', top: 8, right: 8, color: SUBTLE}}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <Box
          component='img'
          src={src}
          alt={alt || 'Evidence image'}
          sx={{maxWidth: '100%', maxHeight: '75vh', display: 'block', borderRadius: '8px'}}
        />
      </DialogContent>
    </Dialog>
  )
}
